import { gql } from '@apollo/client';

import STUDENT_FRAGMENT from '../fragments/student';
import CLASSROOM_FRAGMENT from 'graph/fragments/classroom';
import ORGANIZATION_FRAGMENT from 'graph/fragments/organization';
import EXTERNAL_ID_FRAGMENT from 'graph/fragments/external-id';
import STUDENT_LICENSE_USAGE_FRAGMENT from 'graph/fragments/student-license-usage';
import GROUPS_FRAGMENT from 'graph/fragments/groups';

const GET_STUDENT_AND_CLASSROOM = gql`
  query getStudentAndClassroomQuery(
    $whereStudent: StudentWhereInput!
    $whereClassroom: ClassroomWhereInput!
  ) {
    student(where: $whereStudent) {
      ...BaseStudent
      externalId {
        ...BaseExternalId
      }
      groups {
        ...BaseGroups
      }
      licenseUsage {
        ...BaseStudentLicenseUsage
      }
    }
    classroom(where: $whereClassroom) {
      ...BaseClassroom
      externalId {
        ...BaseExternalId
      }
      students {
        id
        username
      }
      organization {
        ...BaseOrganization
      }
    }
  }
  ${STUDENT_FRAGMENT}
  ${CLASSROOM_FRAGMENT}
  ${EXTERNAL_ID_FRAGMENT}
  ${ORGANIZATION_FRAGMENT}
  ${STUDENT_LICENSE_USAGE_FRAGMENT}
  ${GROUPS_FRAGMENT}
`;

export default GET_STUDENT_AND_CLASSROOM;
